import React from "react";
import Header1 from "./ptfHeader";

const TermsConditions = () => {
  return (
    <div>
      <Header1 />
      <div className="container mx-auto mt-28 mb-16 px-4">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Terms & Conditions</h1>
          <p className="text-gray-500 mb-12">
            Please read these terms carefully before using{" "}
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>
            .
          </p>
        </div>

        {/* 1 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">1.</span>
            <span className="font-semibold text-lg">User Agreement</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            By using this application, you acknowledge that you have read,
            understood, and agreed to be bound by these terms and conditions.
            These terms govern your use of the{" "}
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>{" "}
            website and mobile application.
          </div>
        </div>

        {/* 2 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">2.</span>
            <span className="font-semibold text-lg">
              Modifications to Terms
            </span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>{" "}
            reserves the right to modify these terms at its sole discretion.
            Users are responsible for reviewing the terms periodically to stay
            informed of updates.
          </div>
        </div>

        {/* 3 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">3.</span>
            <span className="font-semibold text-lg">
              Accuracy of Information
            </span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            By registering or placing an order, you confirm that all information
            provided is accurate and truthful. Providing false or misleading
            information may result in legal action.
          </div>
        </div>

        {/* 4 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">4.</span>
            <span className="font-semibold text-lg">Account Termination</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>{" "}
            reserves the right to terminate your account without prior notice
            based on instructions or feedback received from your employer.
          </div>
        </div>

        {/* 5 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">5.</span>
            <span className="font-semibold text-lg">Wallet Policy</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            Funds added to your{" "}
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>{" "}
            wallet are non-refundable. Wallet balances must be used within the
            cafeteria system.
          </div>
        </div>

        {/* 6 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">6.</span>
            <span className="font-semibold text-lg">Order Cancellation</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            Orders can only be cancelled before vendor acceptance. Once
            accepted, orders cannot be cancelled or refunded.
          </div>
        </div>

        {/* 7 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">7.</span>
            <span className="font-semibold text-lg">Refund Policy</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            Refunds to your wallet are applicable only if the vendor is unable
            to fulfill your order due to unavailability or valid reasons.
          </div>
        </div>

        {/* 8 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">8.</span>
            <span className="font-semibold text-lg">Account Security</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            You are responsible for maintaining the confidentiality of your
            login credentials.{" "}
            <span className="bg-gradient-to-r from-blue-500 to-cyan-400 bg-clip-text text-transparent font-semibold">
              MyCafe Connect
            </span>{" "}
            is not liable for losses resulting from unauthorized access.
          </div>
        </div>

        {/* 9 */}
        <div className="bg-white rounded-2xl py-6 px-8 mb-5 shadow-lg border-l-4 border-blue-500 transition-transform duration-300 hover:-translate-y-1 hover:shadow-xl">
          <div className="flex items-center">
            <span className="font-semibold text-blue-500 mr-1.5">9.</span>
            <span className="font-semibold text-lg">Account Deletion</span>
          </div>
          <div className="mt-2.5 text-gray-600 leading-relaxed">
            To delete your account, please contact your employer. Account
            deletion will proceed upon confirmation and instruction from the
            employer.
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
